module.exports = __webpack_public_path__ + "static/media/expediente.1f2880be.png";